var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-login"),
      _vm._v(" "),
      _c("main", { staticClass: "registerScreen" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row --mainRow" }, [
            _c("div", {
              staticClass:
                "col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol"
              },
              [
                _c("ol", { staticClass: "m-stepNavigation" }, [
                  _c(
                    "li",
                    {
                      staticClass: "a-stepNavigation__item",
                      class: {
                        current: _vm.step === "kolektiv",
                        "is-done": ["zoznam", "zhrnutie", "uspech"].includes(
                          _vm.step
                        )
                      }
                    },
                    [_vm._v("Informácie o kolektíve")]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "a-stepNavigation__item",
                      class: {
                        current: _vm.step === "zoznam",
                        "is-done": ["zhrnutie", "uspech"].includes(_vm.step)
                      }
                    },
                    [_vm._v("Zoznam žiakov")]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "a-stepNavigation__item",
                      class: {
                        current: _vm.step === "zhrnutie",
                        "is-done": ["uspech"].includes(_vm.step)
                      }
                    },
                    [_vm._v("Zhrnutie")]
                  )
                ]),
                _vm._v(" "),
                _vm.step === "kolektiv"
                  ? _c("register-kolektiv", {
                      attrs: { form: _vm.form },
                      on: {
                        updateStep: function(newStep) {
                          return (_vm.step = newStep)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === "zoznam"
                  ? _c("register-zoznam", {
                      attrs: { form: _vm.form },
                      on: {
                        updateStep: function(newStep) {
                          return (_vm.step = newStep)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === "zhrnutie"
                  ? _c("register-zhrnutie", {
                      attrs: { form: _vm.form },
                      on: {
                        updateStep: function(newStep) {
                          return (_vm.step = newStep)
                        },
                        submitForm: _vm.register
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "error-message",
                            fn: function() {
                              return [
                                _vm.responseText !== ""
                                  ? _c(
                                      "div",
                                      {
                                        class:
                                          "alert alert-" + _vm.responseType,
                                        attrs: { role: "alert" }
                                      },
                                      [
                                        _c("span", {
                                          class: "icon --" + _vm.responseType
                                        }),
                                        _vm._v(
                                          _vm._s(_vm.responseText) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        740173774
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === "uspech"
                  ? [
                      _c("div", { staticClass: "paddingBox" }, [
                        _c(
                          "p",
                          [
                            _vm._v(
                              "\n                                Vaša registrácia bola úspešná.\n                                Teraz sa "
                            ),
                            _c(
                              "router-link",
                              { attrs: { to: { name: "login" } } },
                              [_vm._v("môžete prihlásiť")]
                            ),
                            _vm._v(".\n                            ")
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }